{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} razgovora je izabrano",
    "AGENT_SELECT_LABEL": "Izaberite agenta",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Povratak",
    "ASSIGN_LABEL": "Dodeli",
    "YES": "Da",
    "SEARCH_INPUT_PLACEHOLDER": "Traži",
    "ASSIGN_AGENT_TOOLTIP": "Dodeli agenta",
    "ASSIGN_TEAM_TOOLTIP": "Dodeli tim",
    "ASSIGN_SUCCESFUL": "Razgovor je uspešno dodeljen.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Razgovor je uspešno rešen.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Jedino razgovori na ovoj stranici su izabrani.",
    "AGENT_LIST_LOADING": "Učitavanje agenata",
    "UPDATE": {
      "CHANGE_STATUS": "Promeni status",
      "SNOOZE_UNTIL": "Odloži",
      "UPDATE_SUCCESFUL": "Status razgovora je uspešno promenjen.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "Nije pronađena nijedna oznaka",
      "ASSIGN_SELECTED_LABELS": "Dodeli izabrane oznake",
      "ASSIGN_SUCCESFUL": "Oznake su uspešno dodeljene.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Izaberite tim",
      "NONE": "Niko",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Spoji razgovore",
      "TITLE": "Spajanje razgovora",
      "DESCRIPTION": "Izaberite ciljni razgovor. Svi ostali izabrani razgovori će biti spojeni u njega — njihove poruke će biti premeštene u ciljni razgovor, a izvorni razgovori će biti obrisani.",
      "TARGET_LABEL": "Ciljni razgovor (biće zadržan)",
      "SOURCES_LABEL": "Izvorni razgovori (biće obrisani)",
      "SELECT_TARGET": "Izaberite razgovor kao cilj spajanja",
      "WARNING": "Upozorenje: Ova radnja se ne može poništiti. Poruke iz svih izvornih razgovora biće premeštene u ciljni razgovor, a izvorni razgovori će biti trajno obrisani.",
      "SUBMIT": "Spoji razgovore",
      "CANCEL": "Otkaži",
      "SUCCESS_MESSAGE": "Razgovori su uspešno spojeni",
      "ERROR_MESSAGE": "Nije moguće spojiti razgovore. Pokušajte ponovo.",
      "CONFIRM": {
        "TITLE": "Potvrdite spajanje",
        "DESCRIPTION": "Da li ste sigurni da želite da spojite {sourceCount} razgovora u #{targetId}? Ova radnja se ne može poništiti.",
        "YES": "Da, spoji",
        "CANCEL": "Otkaži"
      }
    }
  }
}
